import { render, staticRenderFns } from "./ExamQuestionList.vue?vue&type=template&id=0afc7d24&scoped=true"
import script from "./ExamQuestionList.vue?vue&type=script&lang=js"
export * from "./ExamQuestionList.vue?vue&type=script&lang=js"
import style0 from "./ExamQuestionList.vue?vue&type=style&index=0&id=0afc7d24&prod&scoped=true&lang=css"
import style1 from "./ExamQuestionList.vue?vue&type=style&index=1&id=0afc7d24&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0afc7d24",
  null
  
)

export default component.exports